export const setUp = 'setUp'
export const switchingListView = 'switchingListView'
export const setResultCorrectInformation = 'setResultCorrectInformation'
export const setResultIncorrectInformation = 'setResultIncorrectInformation'
export const removeResultCorrectInformation = 'removeResultCorrectInformation'
export const removeResultIncorrectInformation = 'removeResultIncorrectInformation'
export const updateUqList = 'updateUqList'
export const login = 'login'
export const logout = 'logout'
export const setPageNumber = 'setPageNumber'
export const updatePoint = 'updatePoint'
export const onLoadingWait = 'onLoadingWait'
export const offLoadingWait = 'offLoadingWait'
